import { createRouter, createWebHistory } from 'vue-router';
import * as Utils from '@/assets/utils';

import HomeView from './pages/home';
import AboutUsView from './pages/aboutUs';
import ProductServiceView from './pages/productService';
import ClaimsView from './pages/claims';
import QuestionsView from './pages/questions';
import ContactUsView from './pages/contactUs';
import ProtocolView from './pages/protocol';
import RegisterView from './pages/register';
import ResetView from './pages/resetPassword';
// import PlanView from './pages/plan';
import PlanUnitView from './pages/plan/unit.vue';
import PlanPersonView from './pages/plan/person.vue';

// mobile
import MobileHomeView from './mobile/pages/home';
import MobileAboutUsView from './mobile/pages/aboutUs';
import MobileProductServiceView from './mobile/pages/productService';
import MobileClaimsView from './mobile/pages/claims';
import MobileQuestionsView from './mobile/pages/questions';
import MobileContactUsView from './mobile/pages/contactUs';
import MobileProtocolView from './mobile/pages/protocol';
import MobilePlanView from './mobile/pages/plan';
import MobileLoginView from './mobile/pages/login';
import MobileExchangeView from './mobile/pages/exchange';
import MobileRegisterView from './mobile/pages/register';
import MobileResetView from './mobile/pages/resetPassword';

const routes = [
  { path: '/', redirect: 'home' },
  { path: '/home', name: 'home', component: HomeView },
  { path: '/aboutus', name: 'aboutUs', component: AboutUsView },
  { path: '/contactus', name: 'contactUs', component: ContactUsView },
  { path: '/claims', name: 'claims', component: ClaimsView },
  { path: '/questions', name: 'questions', component: QuestionsView },
  { path: '/productservice', name: 'productservice', component: ProductServiceView },
  { path: '/plan/unit', name: 'planUnit', component: PlanUnitView },
  { path: '/plan/person', name: 'planPerson', component: PlanPersonView },
  { path: '/protocol/:target', name: 'protocol', component: ProtocolView },
  { path: '/register', name: 'register', component: RegisterView },
  { path: '/resetpassword', name: 'resetpwd', component: ResetView },

];

const mobileRoutes = [
  { path: '/', redirect: 'home' },
  { path: '/home', name: 'home', component: MobileHomeView },
  { path: '/aboutus', name: 'aboutUs', component: MobileAboutUsView },
  { path: '/contactus', name: 'contactUs', component: MobileContactUsView },
  { path: '/claims', name: 'claims', component: MobileClaimsView },
  { path: '/questions', name: 'questions', component: MobileQuestionsView },
  { path: '/productservice', name: 'productservice', component: MobileProductServiceView },
  { path: '/plan/:target', name: 'plan', component: MobilePlanView },
  { path: '/protocol/:target', name: 'protocol', component: MobileProtocolView },
  { path: '/login', name: 'login', component: MobileLoginView },
  { path: '/exchange', name: 'exchange', component: MobileExchangeView },
  { path: '/register', name: 'register', component: MobileRegisterView },
  { path: '/resetpassword', name: 'resetpwd', component: MobileResetView },
];

export default createRouter({
  history: createWebHistory(),
  routes: Utils.isMobile() ? mobileRoutes : routes,
  scrollBehavior: () => {
    return { left: 0, top: 0 }
  }
})
